import{attributesMap as n}from"./constants.min.mjs";const o=o=>{var r;return null!==(r=n[o])&&void 0!==r?r:o};export{o as normalizeAttr};
//# sourceMappingURL=normalizeAttr.min.mjs.map
